export const menuItems = [
	{ label: "Acceuil", href: "/" },
	{ label: "Portfolio", href: "/portfolio" },
	{ label: "À propos", href: "/about" },
	{ label: "Contact", href: "/contact" },
];

export const socialLinks = [
	{ label: "Instagram", href: "/https://www.instagram.com/codewitholiver/" },
	{ label: "Twitter", href: "/#" },
	{ label: "LinkedIn", href: "/https://www.linkedin.com/in/olivier-geiger-9a763a1b1/#main-content" },
];
